import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getAuth } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import ThemeToggle from '../config/ThemeToggle';
import { Dropdown, DropdownDivider, DropdownItem, DropdownHeader, Tooltip } from 'flowbite-react';
import { FaCog, FaEye } from 'react-icons/fa';
import { Avatar } from 'flowbite-react';
import { Navbar, NavbarToggle, NavbarBrand } from 'flowbite-react';
import { IoNotifications } from "react-icons/io5";
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import { LuAlignLeft } from "react-icons/lu";
import { formatDistanceToNow } from 'date-fns';
import { Badge } from "flowbite-react";
import RequestTypeAvatar from './notifications-body/RequestTypeAvatar';
import NotificationActionsMenu from './notifications-body/NotificationActionsMenu';
import { useNotifications } from '../context/NotificationsContext';




const NavbarComponent = ({ onToggleSidebar }) => {
  const auth = getAuth();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const { notifications, markAsRead, markAsUnread, deleteNotification } = useNotifications();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      const userRef = ref(database, 'users/' + user.uid);
      onValue(userRef, (snapshot) => {
        if (snapshot.exists()) {
          setUserData(snapshot.val());
        }
      });

      // Notifications provided by context; no separate listener needed here.
    }
  }, [auth.currentUser]);

  const handleLogoClick = () => {
    navigate('/user-dashboard')
  };
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNotificationClick = (notificationId, isRead) => {
    navigate(`/user/notifications/${notificationId}`);
    if (!isRead) {
      markAsRead(notificationId);
    }
  };

  // Calculate unread notifications
  const unreadNotificationsCount = notifications.filter(notification => !notification.read).length;

  return (
    <Navbar fluid className="border-b">
      <NavbarBrand>
        <button
          className="lg:hidden text-gray-500 dark:text-white"
          onClick={onToggleSidebar}
        >
          <LuAlignLeft size={30} />
        </button>
        <div onClick={handleLogoClick} className='flex cursor-pointer
        '>
          <img src={'/logo.png'} className="mr-3 h-6 sm:h-9" alt="Flowbite React Logo" />
          <p className='text-blue-600 font-bold text-xl'>BEAMS</p>
        </div>

      </NavbarBrand>

      <div className="flex md:order-2 items-center justify-center">
        <Tooltip content="Dark Mode">
          <ThemeToggle />
        </Tooltip>
        <Tooltip content="Notifications">
          <Dropdown
            arrowIcon={false}
            className="w-full md:w-2/6 shadow-lg dark:shadow-gray-800/80"
            label={
              <div className="relative">
                <IoNotifications className="text-gray-500 dark:text-gray-400" size={32} />
                {/* Show badge if there are unread notifications */}
                {unreadNotificationsCount > 0 && (
                  <Badge className='rounded-2xl p-0.5 absolute top-0 right-0' size='2xs' color="failure">
                    {unreadNotificationsCount}
                  </Badge>
                )}
              </div>
            }
            color="bg-white dark:bg-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <Dropdown.Header>
              <span className="block truncate text-m font-medium text-start">Notifications</span>
            </Dropdown.Header>

{notifications.length > 0 ? (
  notifications
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    .slice(0, 10)
    .map((notification) => (
      <Dropdown.Item
        key={notification.id}
        className={notification.read ? 'bg-white dark:bg-gray-700' : 'bg-gray-100 dark:bg-gray-500'}
        onClick={() => handleNotificationClick(notification.id, notification.read)}
      >
        <div className="flex items-start gap-3 w-full">
          <RequestTypeAvatar requestType={notification.requestType} size="md" className="shrink-0" />
          <div className="text-sm flex-1">
            <p className="font-medium text-start dark:text-white">
              <span className="text-gray-800 dark:text-gray-200">
                {notification.message}
              </span>
            </p>
            <div className="flex items-center gap-2 text-xs text-gray-400 text-start">
              {(() => {
                const refNo = notification?.requestData?.referenceNo;
                const hasTime = notification.timestamp && !isNaN(new Date(notification.timestamp).getTime());
                const timeAgo = hasTime ? formatDistanceToNow(new Date(notification.timestamp), { addSuffix: true }) : '';
                return (
                  <>
                    {hasTime && <span>{timeAgo}</span>}
                    {refNo && hasTime && <span>•</span>}
                    {refNo && <span>Ref No. {refNo}</span>}
                  </>
                );
              })()}
            </div>
          </div>
          <NotificationActionsMenu notification={notification} />
        </div>
      </Dropdown.Item>
    ))
) : (
  <Dropdown.Item>No notifications available.</Dropdown.Item>
)}

            <Link to="/user/notifications" className="bg-gray-400">
              <span className="truncate text-m font-medium flex items-center justify-center gap-2 text-center p-2">
                <FaEye /> View All Notifications
              </span>
            </Link>
          </Dropdown>
        </Tooltip>
        <Dropdown
          arrowIcon={false}
          inline
          label={<Avatar img={userData?.userPhoto || '/logo.png'} alt="User settings" rounded />}
        >
          <DropdownHeader>
            {userData && (
              <>
                <span className="block text-sm">{userData.firstName} {userData.lastName}</span>
                <span className="block truncate text-sm font-medium">{userData.email}</span>
              </>
            )}
          </DropdownHeader>
          <DropdownItem onClick={() => navigate('/user/settings')}>Settings</DropdownItem>
          <DropdownDivider />
          <DropdownItem onClick={handleLogout}>Sign out</DropdownItem>
        </Dropdown>

      </div>
    </Navbar>
  );
};

export default NavbarComponent;
